import React from 'react'
import styles from './AmountRangeFilter.module.css'

export type AmountRangeValue = { from?: string; to?: string }

interface AmountRangeFilterProps {
  value: AmountRangeValue | undefined
  onChange: (v: AmountRangeValue) => void
  label?: string
}

const AMOUNT = /^\d*([.,]\d{0,2})?$/

/**
 * Amount bounds for FilterManager, mounted under `amountRange`: one control «от | до» styled like the
 * selects beside it. Strings, not numbers: the field must be able to hold an unfinished value like
 * `15.`; the page converts on apply.
 */
export function AmountRangeFilter({ value, onChange, label = 'Сумма' }: AmountRangeFilterProps) {
  const current = value ?? {}
  const set = (key: 'from' | 'to') => (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value
    if (!AMOUNT.test(next)) return
    onChange({ ...current, [key]: next })
  }

  return (
    <>
      <label className='fs-7 form-label fw-bolder text-dark mb-1'>{label}</label>
      <div className={styles.field}>
        <input
          className={`form-control ${styles.input}`}
          type='text'
          inputMode='decimal'
          aria-label={`${label} от`}
          placeholder='от'
          value={current.from ?? ''}
          onChange={set('from')}
        />
        <span className={styles.separator} aria-hidden='true' />
        <input
          className={`form-control ${styles.input}`}
          type='text'
          inputMode='decimal'
          aria-label={`${label} до`}
          placeholder='до'
          value={current.to ?? ''}
          onChange={set('to')}
        />
      </div>
    </>
  )
}

export default AmountRangeFilter
